import React from 'react';
import { Helmet } from 'react-helmet-async';

const Miles = ({ title, description }) => {

  return (
    <> 
<Helmet>
    <title>{title || 'EMI Miles - EnbyBase Official Website'}</title>
    <meta name="description" content={description || 'EMI Miles of EnbyBase • TransBase'} />
    <meta property="og:title" content={title || 'EMI Miles - EnbyBase Official Website'}/>
    <meta property="og:description" content={description || 'EMI Miles of EnbyBase • TransBase'}/>
  </Helmet>

    
      <div
        className="hero"
        style={{
          boxSizing: "inherit",
          display: "block",
          paddingTop: "120px",
          background:
            'url("https://firebasestorage.googleapis.com/v0/b/enbybase.appspot.com/o/cdn2%2Fworld-curve-muun.png?alt=media&token=1cd0d278-2c7b-40e5-9b9d-8b3c41d6e436") center bottom no-repeat, center bottom -400px no-repeat',
          clear: "both",
          paddingBottom: "400px",
        }}
      >
        <div
          className="container"
          style={{
            boxSizing: "inherit",
            width: "100%",
            paddingRight: "16px",
            paddingLeft: "16px",
            marginRight: "auto",
            marginLeft: "auto",
            maxWidth: "1068px",
            position: "relative",
          }}
        >
          <canvas
            height={600}
            width={800}
            style={{ boxSizing: "inherit", display: "none" }}
          />
          <h1
            style={{
              boxSizing: "inherit",
              marginTop: "0px",
              fontSize: "56px",
              lineHeight: "125%",
              marginBottom: "16px",
            }}
          >
            Simple and Powerful.
            <br style={{ boxSizing: "inherit" }} />
            EnbyBase Miles Interface.
          </h1>
          <p
            style={{
              boxSizing: "inherit",
              marginTop: "0px",
              marginBottom: "16px",
              fontSize: "22px",
              lineHeight: "160%",
            }}
          >
            EMI is a frequent miles programme of EnbyBase Alliance. The revolution of the Community.
          </p>
          <div
            className="store-links d-md-block"
            style={{
              boxSizing: "inherit",
              marginTop: "24px",
              display: "block",
            }}
          >
            <div
              className="col-mobile"
              style={{ boxSizing: "inherit", display: "inline-block" }}
            >
              <a
                className="btn-app-store"
                 href='/account'
                style={{
                  boxSizing: "inherit",
                  textDecoration: "none",
                  borderRadius: "10px",
                  padding: "13px 10px",
                  display: "inline-block",
                  width: "152px",
                  height: "48px",
                  textAlign: "center",
                  color: "rgb(255, 255, 255)",
                  backgroundColor: "#9C59D1",
                  marginRight: "16px",
                  fontWeight: 500,
                }}
              >
                <span
                  className="icon icon-app-store"
                  style={{
                    boxSizing: "inherit",
                    display: "inline",
                    paddingBottom: "6px",
                     top: "-2px",
                    backgroundPosition: "0px 0px",
                  }}
                />
                Log-In
              </a>
            </div>
            <div
              className="col-mobile"
              style={{ boxSizing: "inherit", display: "inline-block" }}
            >
              <a
                className="btn-play-store"
                href="https://forms.gle/UbZH5U6PQ1t71txw5" target="blank"
                style={{
                  boxSizing: "inherit",
                  textDecoration: "none",
                  borderRadius: "10px",
                  padding: "13px 10px",
                  display: "inline-block",
                  width: "152px",
                  height: "48px",
                  textAlign: "center",
                  color: "rgb(255, 255, 255)",
                  backgroundColor: "#9C59D1",
                  marginRight: "16px",
                  fontWeight: 500,
                }}
              >
                <span
                  className="icon icon-play-store"
                  style={{
                    boxSizing: "inherit",
                    display: "inline",
                    paddingBottom: "6px",
                    position: "relative",
                    top: "-2px",
                    backgroundPosition: "0px 0px",
                  }}
                />
                Register
              </a>
            </div>
          </div>
          <img
            className="astronaut-img"
            height={193}
            width={97}
            src="https://muun.com/static/astronaut-ac30bd7cfe6201409b07f83894433fd0.png"
            style={{
              boxSizing: "inherit",
              borderStyle: "none",
              verticalAlign: "middle",
              position: "absolute",
              right: "50px",
              bottom: "-170px",
            }}
          />
        </div>
      </div> 
    </>
    );
  }
  
  export default Miles;